import { render } from "./UiImageSlider.vue?vue&type=template&id=7bccacf8"
import script from "./UiImageSlider.vue?vue&type=script&lang=js"
export * from "./UiImageSlider.vue?vue&type=script&lang=js"

import "./UiImageSlider.vue?vue&type=style&index=0&id=7bccacf8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__